export const sort_right = () => (
  <path
    d="M5 12h14m0 0l-4-4m4 4l-4 4"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
